var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/gallery"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66794 19.0093L2.64784 19.0293C2.37647 18.4393 2.20561 17.7693 2.13525 17.0293C2.20561 17.7593 2.39657 18.4193 2.66794 19.0093Z",
    fill: "#49028E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.1206 10.3791C10.4417 10.3791 11.5127 9.31358 11.5127 7.99914C11.5127 6.6847 10.4417 5.61914 9.1206 5.61914C7.79949 5.61914 6.72852 6.6847 6.72852 7.99914C6.72852 9.31358 7.79949 10.3791 9.1206 10.3791Z",
    fill: "#49028E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.347 2H7.92445C4.26598 2 2.08496 4.17 2.08496 7.81V16.19C2.08496 17.28 2.27593 18.23 2.6478 19.03C3.51217 20.93 5.36151 22 7.92445 22H16.347C20.0055 22 22.1865 19.83 22.1865 16.19V13.9V7.81C22.1865 4.17 20.0055 2 16.347 2ZM20.5482 12.5C19.7643 11.83 18.4979 11.83 17.7139 12.5L13.5328 16.07C12.7488 16.74 11.4824 16.74 10.6985 16.07L10.3567 15.79C9.64313 15.17 8.5074 15.11 7.70334 15.65L3.94435 18.16C3.72324 17.6 3.59258 16.95 3.59258 16.19V7.81C3.59258 4.99 5.09014 3.5 7.92445 3.5H16.347C19.1813 3.5 20.6789 4.99 20.6789 7.81V12.61L20.5482 12.5Z",
    fill: "#49028E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/icon_gallery.6b6e65447fcfa8ef905b84a5cec172f6.svg";
export { ForwardRef as ReactComponent };